import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail } from '@/api/MLXC/countryGovern/suggestManage';
export default {
  props: {
    showDialog: Boolean,
    keyValue: {
      type: Number,
      default: -1
    }
  },
  data: function data() {
    return {
      rules: {
        appointmentTime: [{
          required: true,
          message: '请选择预约处理时间',
          trigger: 'change'
        }],
        contact: [{
          required: true,
          message: '请输入联系人',
          trigger: 'blur'
        }, {
          max: 100,
          message: '最多输入50个字符',
          trigger: 'change'
        }],
        phone: [{
          required: true,
          message: '请输入联系人电话',
          trigger: 'blur'
        }, {
          min: 11,
          max: 11,
          message: '请输入11位手机号',
          trigger: 'change'
        }],
        eventalSite: [{
          required: true,
          message: '请输入问题发生地',
          trigger: 'blur'
        }, {
          max: 100,
          message: '最多输入100个字符',
          trigger: 'change'
        }],
        situationType: [{
          required: true,
          message: '请选择紧急情况',
          trigger: 'change'
        }],
        complaintAddress: [{
          required: true,
          message: '请输入投诉地址',
          trigger: 'blur'
        }, {
          max: 100,
          message: '最多输入100个字符',
          trigger: 'change'
        }],
        complaintContent: [{
          required: true,
          message: '请输入投诉内容',
          trigger: 'blur'
        }, {
          max: 200,
          message: '最多输入300个字符',
          trigger: 'change'
        }]
      },
      statusOption: [{
        name: '未处理',
        value: 1
      }, {
        name: '处理中',
        value: 2
      }, {
        name: '已处理',
        value: 3
      }],
      sourceOption: [{
        name: '微信',
        value: 1
      }, {
        name: '电话',
        value: 2
      }, {
        name: '现场登记',
        value: 3
      }],
      situationOption: [{
        name: '紧急',
        value: 0
      }, {
        name: '一般',
        value: 1
      }],
      userName: this.$store.state.user.name,
      complainantsPhone: this.$store.state.user.userPhone,
      childData: {}
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
        });
      } else {
        this.childData = {};
      }
    },
    handCreate: function handCreate() {
      var _this2 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this2.keyValue > 0) {
            fetchUpdate(_this2.childData).then(function () {
              _this2.$emit('handCancle', true);

              _this2.Alert({
                alertType: 'update'
              });
            });
          } else {
            fetchCreate(_this2.childData).then(function () {
              _this2.$emit('handCancle', true);

              _this2.Alert({
                alertType: 'add'
              });
            });
          }
        } else {
          _this2.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  }
};